import {
	faSortAmountDownAlt,
	faSortAmountUpAlt,
} from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { components, ControlProps } from 'react-select'

const deadlineExpiredKey = 'challenge_submit_deadline_expired'

const SortDirectionControl = ({
	children,
	...props
}: ControlProps<any, any>) => {
	const [item] = props.getValue()

	const itemOptionsArray = item?.value?.split(',').filter((a) => Boolean(a))

	const icon = itemOptionsArray
		.filter((a) => !a.includes(deadlineExpiredKey))[0]
		.includes('-')
		? faSortAmountUpAlt
		: faSortAmountDownAlt

	//EVERY VALUE inside the array, will have "-" either removed or added
	const updateValue = () => {
		if (!item) return

		const result = itemOptionsArray.map((a) => {
			if (a.includes(deadlineExpiredKey)) {
				return a
			}

			if (a.startsWith('-')) {
				return a.substring(1)
			} else {
				return '-' + a
			}
		})

		props.setValue({ ...item, value: result.join(',') })
	}

	// @ts-ignore
	return (
		<components.Control {...props} style={{ touchAction: 'none' }}>
			<button
				onMouseDown={(e) => {
					updateValue()
					e.preventDefault()
					e.stopPropagation()
				}}
				onTouchStart={() => {
					updateValue()
				}}
				onTouchEnd={(e) => {
					e.preventDefault()
					e.stopPropagation()
				}}
				className="ml-2 cursor-pointer p-0 text-gray-800 hover:text-blue-500"
			>
				<FontAwesomeIcon icon={icon} />
			</button>
			{children}
		</components.Control>
	)
}

export default SortDirectionControl
